/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimeSeries } from './TimeSeries';
import {
    TimeSeriesFromJSON,
    TimeSeriesFromJSONTyped,
    TimeSeriesToJSON,
    TimeSeriesToJSONTyped,
} from './TimeSeries';

/**
 * 
 * @export
 * @interface OperatorPrognosisMonetaryRepresentation
 */
export interface OperatorPrognosisMonetaryRepresentation {
    /**
     * 
     * @type {TimeSeries}
     * @memberof OperatorPrognosisMonetaryRepresentation
     */
    budgetMonetary: TimeSeries;
    /**
     * 
     * @type {TimeSeries}
     * @memberof OperatorPrognosisMonetaryRepresentation
     */
    forecastMonetary: TimeSeries;
    /**
     * 
     * @type {TimeSeries}
     * @memberof OperatorPrognosisMonetaryRepresentation
     */
    actualGross: TimeSeries;
    /**
     * 
     * @type {TimeSeries}
     * @memberof OperatorPrognosisMonetaryRepresentation
     */
    actualNet: TimeSeries;
    /**
     * 
     * @type {TimeSeries}
     * @memberof OperatorPrognosisMonetaryRepresentation
     */
    einsman: TimeSeries;
    /**
     * 
     * @type {TimeSeries}
     * @memberof OperatorPrognosisMonetaryRepresentation
     */
    actualPlusFC: TimeSeries;
    /**
     * 
     * @type {TimeSeries}
     * @memberof OperatorPrognosisMonetaryRepresentation
     */
    actualVsBudget: TimeSeries;
    /**
     * 
     * @type {TimeSeries}
     * @memberof OperatorPrognosisMonetaryRepresentation
     */
    actualVsFC: TimeSeries;
    /**
     * 
     * @type {TimeSeries}
     * @memberof OperatorPrognosisMonetaryRepresentation
     */
    weightedPlanCommission: TimeSeries;
    /**
     * 
     * @type {TimeSeries}
     * @memberof OperatorPrognosisMonetaryRepresentation
     */
    weightedActualCommission: TimeSeries;
}

/**
 * Check if a given object implements the OperatorPrognosisMonetaryRepresentation interface.
 */
export function instanceOfOperatorPrognosisMonetaryRepresentation(value: object): value is OperatorPrognosisMonetaryRepresentation {
    if (!('budgetMonetary' in value) || value['budgetMonetary'] === undefined) return false;
    if (!('forecastMonetary' in value) || value['forecastMonetary'] === undefined) return false;
    if (!('actualGross' in value) || value['actualGross'] === undefined) return false;
    if (!('actualNet' in value) || value['actualNet'] === undefined) return false;
    if (!('einsman' in value) || value['einsman'] === undefined) return false;
    if (!('actualPlusFC' in value) || value['actualPlusFC'] === undefined) return false;
    if (!('actualVsBudget' in value) || value['actualVsBudget'] === undefined) return false;
    if (!('actualVsFC' in value) || value['actualVsFC'] === undefined) return false;
    if (!('weightedPlanCommission' in value) || value['weightedPlanCommission'] === undefined) return false;
    if (!('weightedActualCommission' in value) || value['weightedActualCommission'] === undefined) return false;
    return true;
}

export function OperatorPrognosisMonetaryRepresentationFromJSON(json: any): OperatorPrognosisMonetaryRepresentation {
    return OperatorPrognosisMonetaryRepresentationFromJSONTyped(json, false);
}

export function OperatorPrognosisMonetaryRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): OperatorPrognosisMonetaryRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'budgetMonetary': TimeSeriesFromJSON(json['budgetMonetary']),
        'forecastMonetary': TimeSeriesFromJSON(json['forecastMonetary']),
        'actualGross': TimeSeriesFromJSON(json['actualGross']),
        'actualNet': TimeSeriesFromJSON(json['actualNet']),
        'einsman': TimeSeriesFromJSON(json['einsman']),
        'actualPlusFC': TimeSeriesFromJSON(json['actualPlusFC']),
        'actualVsBudget': TimeSeriesFromJSON(json['actualVsBudget']),
        'actualVsFC': TimeSeriesFromJSON(json['actualVsFC']),
        'weightedPlanCommission': TimeSeriesFromJSON(json['weightedPlanCommission']),
        'weightedActualCommission': TimeSeriesFromJSON(json['weightedActualCommission']),
    };
}

export function OperatorPrognosisMonetaryRepresentationToJSON(json: any): OperatorPrognosisMonetaryRepresentation {
    return OperatorPrognosisMonetaryRepresentationToJSONTyped(json, false);
}

export function OperatorPrognosisMonetaryRepresentationToJSONTyped(value?: OperatorPrognosisMonetaryRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'budgetMonetary': TimeSeriesToJSON(value['budgetMonetary']),
        'forecastMonetary': TimeSeriesToJSON(value['forecastMonetary']),
        'actualGross': TimeSeriesToJSON(value['actualGross']),
        'actualNet': TimeSeriesToJSON(value['actualNet']),
        'einsman': TimeSeriesToJSON(value['einsman']),
        'actualPlusFC': TimeSeriesToJSON(value['actualPlusFC']),
        'actualVsBudget': TimeSeriesToJSON(value['actualVsBudget']),
        'actualVsFC': TimeSeriesToJSON(value['actualVsFC']),
        'weightedPlanCommission': TimeSeriesToJSON(value['weightedPlanCommission']),
        'weightedActualCommission': TimeSeriesToJSON(value['weightedActualCommission']),
    };
}

